import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { Document, Page, View } from '../../compiler'
import { colors, typoStyles } from '../../constants'
import MarkdownText from '../MarkdownText'

const RequirementProfileLoading = () => {
  const pageProps = {
    style: { paddingTop: 64 }
  }

  return (
    <Document>
      {/** HEADER + SUMMARY - Overview Section */}
      <Page>
        <View>
          {/** Title & Description */}
          <View style={{ marginHorizontal: 40 }}>
            <MarkdownText
              style={[
                { display: 'block' },
                typoStyles.H2Black,
                { lineHeight: 1.2, marginBottom: 4 }
              ]}
            >
              <Skeleton width={200} />
            </MarkdownText>
            <MarkdownText
              style={[
                { display: 'block' },
                typoStyles.T1Black,
                { lineHeight: 1.2 }
              ]}
            >
              <Skeleton />
            </MarkdownText>
          </View>

          {/** Summary Section */}
          <View
            id='requirement_profile_summary_section'
            style={{ marginHorizontal: 24, marginTop: 26 }}
          >
            <View
              style={{
                borderBottomWidth: 4,
                borderBottomColor: '#DFE4FC',
                backgroundColor: '#F5F7FA',
                paddingHorizontal: 24,
                paddingVertical: 16,
                borderTopLeftRadius: 4,
                borderTopRightRadius: 4,
                borderLeftWidth: 1,
                borderTopWidth: 1,
                borderRightWidth: 1,
                borderLeftColor: '#EBF0F5',
                borderTopColor: '#EBF0F5',
                borderRightColor: '#EBF0F5',
                flexDirection: 'row',
                alignItems: 'center'
              }}
            >
              <Skeleton
                width={24}
                height={24}
                className='mr-4 size-10 rounded-md'
              />
              <MarkdownText style={typoStyles.H4Black}>
                <Skeleton width={200} />
              </MarkdownText>
            </View>
            <View
              style={{
                backgroundColor: '#FAFBFC',
                borderLeftColor: '#EBF0F5',
                borderBottomColor: '#EBF0F5',
                borderRightColor: '#EBF0F5',
                borderLeftWidth: 1,
                borderBottomWidth: 1,
                borderRightWidth: 1,
                borderBottomLeftRadius: 4,
                borderBottomRightRadius: 4
              }}
            >
              {/** Must Criteria */}
              <View
                style={{
                  padding: 24,
                  borderBottomWidth: 1,
                  borderBottomColor: '#EBF0F5'
                }}
              >
                <MarkdownText
                  style={[
                    typoStyles.T2MediumBlue,
                    { textTransform: 'uppercase' }
                  ]}
                >
                  <Skeleton width={100} />
                </MarkdownText>
                {[1, 2].map((_, index) => (
                  <View
                    key={index}
                    style={{
                      marginTop: 16,
                      flexDirection: 'row',
                      alignItems: 'center'
                    }}
                  >
                    <Skeleton width={16} height={17} />
                    <MarkdownText
                      style={[typoStyles.T1Black, { marginLeft: 18 }]}
                    >
                      <Skeleton width={200} />
                    </MarkdownText>
                  </View>
                ))}
              </View>

              {/** Advantageous */}
              <View
                style={{
                  padding: 24,
                  borderBottomWidth: 1,
                  borderBottomColor: '#EBF0F5'
                }}
              >
                <MarkdownText
                  style={[
                    typoStyles.T2MediumBlue,
                    { textTransform: 'uppercase' }
                  ]}
                >
                  <Skeleton width={100} />
                </MarkdownText>
                {[1, 2, 3].map((_, index) => (
                  <View
                    key={index}
                    style={{
                      marginTop: 16,
                      flexDirection: 'row',
                      alignItems: 'center'
                    }}
                  >
                    <Skeleton width={16} height={17} />
                    <MarkdownText
                      style={[typoStyles.T1Black, { marginLeft: 18 }]}
                    >
                      <Skeleton width={200} />
                    </MarkdownText>
                  </View>
                ))}
              </View>

              {/** Interview Recommendations */}
              <View style={{ padding: 24 }}>
                <MarkdownText
                  style={[
                    typoStyles.T2MediumBlue,
                    { textTransform: 'uppercase' }
                  ]}
                >
                  <Skeleton width={100} />
                </MarkdownText>
                {[1, 2, 3].map((_, index) => (
                  <View
                    key={index}
                    style={{
                      marginTop: 16,
                      flexDirection: 'row',
                      alignItems: 'center'
                    }}
                  >
                    <Skeleton width={16} height={17} />
                    <MarkdownText
                      style={[typoStyles.T1Black, { marginLeft: 18 }]}
                    >
                      <Skeleton width={200} />
                    </MarkdownText>
                  </View>
                ))}
              </View>
            </View>
          </View>
        </View>
      </Page>

      {/** SKILLS SECTION */}
      <Page id='requirement_profile_skills_section' {...pageProps}>
        {/** Title & Description */}
        <View style={{ marginHorizontal: 40 }}>
          <MarkdownText
            style={[
              { display: 'block' },
              typoStyles.H2Black,
              { lineHeight: 1.2, marginBottom: 4 }
            ]}
          >
            <Skeleton width={200} />
          </MarkdownText>
          <MarkdownText
            style={[
              { display: 'block' },
              typoStyles.T1Black,
              { lineHeight: 1.2 }
            ]}
          >
            <Skeleton />
          </MarkdownText>
        </View>

        <View style={{ marginTop: 10 }} />
        {[1, 2, 3].map((_, index) => (
          <View
            key={index}
            style={{ marginTop: 16 }}
            id={`requirement_profile_skills_section_${index}`}
          >
            {/** DimensionCard Loading */}
            <View style={{ paddingHorizontal: 24 }}>
              <View
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  paddingHorizontal: 24,
                  height: 72,
                  backgroundColor: '#fff',
                  borderTopLeftRadius: 8,
                  borderTopRightRadius: 8,
                  borderLeftWidth: 1,
                  borderTopWidth: 1,
                  borderRightWidth: 1,
                  borderColor: '#EBF0F5'
                }}
              >
                <View style={{ flexDirection: 'row', alignItems: 'flex-end' }}>
                  <View
                    className='flex flex-row items-center gap-x-1'
                    style={{ flexDirection: 'row', alignItems: 'center' }}
                  >
                    <MarkdownText
                      style={[
                        typoStyles.H4Black,
                        { textTransform: 'uppercase', textAlign: 'left' }
                      ]}
                    >
                      <Skeleton width={150} />
                    </MarkdownText>
                    <Skeleton width={24} height={24} circle />
                  </View>
                </View>
                <View style={{ width: 452 }}>
                  <Skeleton height={40} />
                  <View
                    style={{
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      marginTop: 8
                    }}
                  >
                    <MarkdownText style={typoStyles.SmallBlack}>
                      <Skeleton width={80} />
                    </MarkdownText>
                    <MarkdownText style={typoStyles.SmallBlack}>
                      <Skeleton width={80} />
                    </MarkdownText>
                  </View>
                </View>
              </View>
              <View
                style={{
                  borderTopWidth: 1,
                  backgroundColor: '#FAFBFC',
                  padding: 24,
                  borderBottomLeftRadius: 8,
                  borderBottomRightRadius: 8,
                  borderLeftWidth: 1,
                  borderBottomWidth: 1,
                  borderRightWidth: 1,
                  borderColor: '#EBF0F5'
                }}
              >
                <MarkdownText
                  style={[
                    typoStyles.T1Black,
                    { width: '75%', lineHeight: 1.5 }
                  ]}
                >
                  <Skeleton count={2} />
                </MarkdownText>
              </View>
            </View>
          </View>
        ))}
      </Page>

      {/** PERSONALITY SECTION */}
      <Page id='requirement_profile_personality_section' {...pageProps}>
        {/** Title & Description */}
        <View style={{ marginHorizontal: 40 }}>
          <MarkdownText
            style={[
              { display: 'block' },
              typoStyles.H2Black,
              { lineHeight: 1.2, marginBottom: 4 }
            ]}
          >
            <Skeleton width={200} />
          </MarkdownText>
          <MarkdownText
            style={[
              { display: 'block' },
              typoStyles.T1Black,
              { lineHeight: 1.2 }
            ]}
          >
            <Skeleton />
          </MarkdownText>
        </View>

        <View style={{ marginTop: 10 }} />
        {[1, 2, 3].map((_, index) => (
          <View
            key={index}
            style={{ marginTop: 16 }}
            id={`requirement_profile_personality_section_${index}`}
          >
            {/** DimensionCard Loading */}
            <View style={{ paddingHorizontal: 24 }}>
              <View
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  paddingHorizontal: 24,
                  height: 72,
                  backgroundColor: '#fff',
                  borderTopLeftRadius: 8,
                  borderTopRightRadius: 8,
                  borderLeftWidth: 1,
                  borderTopWidth: 1,
                  borderRightWidth: 1,
                  borderColor: '#EBF0F5'
                }}
              >
                <View style={{ flexDirection: 'row', alignItems: 'flex-end' }}>
                  <View
                    className='flex flex-row items-center gap-x-1'
                    style={{ flexDirection: 'row', alignItems: 'center' }}
                  >
                    <MarkdownText
                      style={[
                        typoStyles.H4Black,
                        { textTransform: 'uppercase', textAlign: 'left' }
                      ]}
                    >
                      <Skeleton width={150} />
                    </MarkdownText>
                    <Skeleton width={24} height={24} circle />
                  </View>
                </View>
                <View style={{ width: 452 }}>
                  <Skeleton height={40} />
                  <View
                    style={{
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      marginTop: 8
                    }}
                  >
                    <MarkdownText style={typoStyles.SmallBlack}>
                      <Skeleton width={80} />
                    </MarkdownText>
                    <MarkdownText style={typoStyles.SmallBlack}>
                      <Skeleton width={80} />
                    </MarkdownText>
                  </View>
                </View>
              </View>
              <View
                style={{
                  borderTopWidth: 1,
                  backgroundColor: '#FAFBFC',
                  padding: 24,
                  borderBottomLeftRadius: 8,
                  borderBottomRightRadius: 8,
                  borderLeftWidth: 1,
                  borderBottomWidth: 1,
                  borderRightWidth: 1,
                  borderColor: '#EBF0F5'
                }}
              >
                <MarkdownText
                  style={[
                    typoStyles.T1Black,
                    { width: '75%', lineHeight: 1.5 }
                  ]}
                >
                  <Skeleton count={2} />
                </MarkdownText>
              </View>
            </View>
          </View>
        ))}
      </Page>

      {/** CULTURE SECTION */}
      <Page {...pageProps}>
        {/** Title & Description */}
        <View style={{ marginHorizontal: 40 }}>
          <MarkdownText
            style={[
              { display: 'block' },
              typoStyles.H2Black,
              { lineHeight: 1.2, marginBottom: 4 }
            ]}
          >
            <Skeleton width={200} />
          </MarkdownText>
          <MarkdownText
            style={[
              { display: 'block' },
              typoStyles.T1Black,
              { lineHeight: 1.2 }
            ]}
          >
            <Skeleton />
          </MarkdownText>
        </View>

        <View
          id='requirement_profile_culture_section'
          style={{ marginHorizontal: 24, marginTop: 26 }}
        >
          <View
            style={{
              borderTopLeftRadius: 8,
              borderTopRightRadius: 8,
              borderWidth: 1,
              borderColor: colors.lightGrey,
              height: 72,
              paddingHorizontal: 24,
              alignItems: 'center'
            }}
          >
            <MarkdownText style={typoStyles.H4Black}>
              <Skeleton width={200} />
            </MarkdownText>
          </View>
          <View
            style={{
              borderLeftWidth: 1,
              borderRightWidth: 1,
              borderColor: colors.lightGrey
            }}
          >
            {/** CoordinateSystem Loading */}
            <div className='flex items-center justify-center p-8'>
              <Skeleton width={510} height={356} />
            </div>
          </View>

          <View
            style={{
              borderBottomLeftRadius: 8,
              borderBottomRightRadius: 8,
              backgroundColor: colors.lightPaleGrey,
              borderWidth: 1,
              borderColor: colors.lightGrey,
              padding: 24
            }}
          >
            {Array(3)
              .fill(null)
              .map((_, index) => (
                <Skeleton
                  key={index}
                  width='100%'
                  height={20}
                  style={{ marginTop: index === 0 ? 0 : 16 }}
                />
              ))}
          </View>
        </View>
      </Page>

      {/** INTERESTS SECTION */}
      <Page id='requirement_profile_interests_section' {...pageProps}>
        {/** Title & Description */}
        <View style={{ marginHorizontal: 40 }}>
          <MarkdownText
            style={[
              { display: 'block' },
              typoStyles.H2Black,
              { lineHeight: 1.2, marginBottom: 4 }
            ]}
          >
            <Skeleton width={200} />
          </MarkdownText>
          <MarkdownText
            style={[
              { display: 'block' },
              typoStyles.T1Black,
              { lineHeight: 1.2 }
            ]}
          >
            <Skeleton />
          </MarkdownText>
        </View>

        {/** Top Interests Loading */}
        <View style={{ marginHorizontal: 24, marginTop: 26 }}>
          <View
            style={{
              borderTopLeftRadius: 8,
              borderTopRightRadius: 8,
              borderWidth: 1,
              borderColor: '#EBF0F5',
              height: 72,
              paddingHorizontal: 24,
              alignItems: 'center'
            }}
          >
            <MarkdownText
              style={[typoStyles.H4Black, { textTransform: 'uppercase' }]}
            >
              <Skeleton width={150} />
            </MarkdownText>
          </View>
          <View
            style={{
              borderColor: '#EBF0F5',
              borderLeftWidth: 1,
              borderRightWidth: 1,
              borderBottomWidth: 1,
              paddingVertical: 16
            }}
          >
            {[1, 2, 3].map((_, index) => (
              <View
                key={index}
                style={{
                  paddingHorizontal: 24,
                  flexDirection: 'row',
                  alignItems: 'center',
                  height: 72
                }}
              >
                <View style={{ paddingRight: 12 }}>
                  <View
                    style={{
                      height: 40,
                      width: 40,
                      borderRadius: 20,
                      borderWidth: 2,
                      borderColor: colors.primaryBlue,
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <MarkdownText style={typoStyles.T1Blue}>
                      {`0${index + 1}`}
                    </MarkdownText>
                  </View>
                </View>
                <View>
                  <MarkdownText style={typoStyles.H4Black}>
                    <Skeleton width={120} />
                  </MarkdownText>
                </View>
              </View>
            ))}
          </View>
          <View
            style={{
              borderBottomLeftRadius: 8,
              borderBottomRightRadius: 8,
              backgroundColor: colors.lightPaleGrey,
              borderBottomWidth: 1,
              borderLeftWidth: 1,
              borderRightWidth: 1,
              borderColor: colors.lightGrey,
              padding: 24
            }}
          >
            <MarkdownText style={typoStyles.T1Black}>
              <Skeleton count={2} />
            </MarkdownText>
          </View>
        </View>

        {/** RIASEC Elevation Loading */}
        <View style={{ paddingHorizontal: 24, marginTop: 16 }}>
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              paddingHorizontal: 24,
              height: 72,
              backgroundColor: '#fff',
              borderTopLeftRadius: 8,
              borderTopRightRadius: 8,
              borderLeftWidth: 1,
              borderTopWidth: 1,
              borderRightWidth: 1,
              borderColor: '#EBF0F5'
            }}
          >
            <View style={{ flexDirection: 'row', alignItems: 'flex-end' }}>
              <View
                className='flex flex-row items-center gap-x-1'
                style={{ flexDirection: 'row', alignItems: 'center' }}
              >
                <MarkdownText
                  style={[
                    typoStyles.H4Black,
                    { textTransform: 'uppercase', textAlign: 'left' }
                  ]}
                >
                  <Skeleton width={150} />
                </MarkdownText>
                <Skeleton width={24} height={24} circle />
              </View>
            </View>
            <View style={{ width: 452 }}>
              <Skeleton height={40} />
              <View
                style={{
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  marginTop: 8
                }}
              >
                <MarkdownText style={typoStyles.SmallBlack}>
                  <Skeleton width={80} />
                </MarkdownText>
                <MarkdownText style={typoStyles.SmallBlack}>
                  <Skeleton width={80} />
                </MarkdownText>
              </View>
            </View>
          </View>
          <View
            style={{
              borderTopWidth: 1,
              backgroundColor: '#FAFBFC',
              padding: 24,
              borderBottomLeftRadius: 8,
              borderBottomRightRadius: 8,
              borderLeftWidth: 1,
              borderBottomWidth: 1,
              borderRightWidth: 1,
              borderColor: '#EBF0F5'
            }}
          >
            <MarkdownText
              style={[typoStyles.T1Black, { width: '75%', lineHeight: 1.5 }]}
            >
              <Skeleton count={2} />
            </MarkdownText>
          </View>
        </View>
      </Page>
    </Document>
  )
}

export default RequirementProfileLoading
